import React from 'react'
import styled from '@emotion/styled'
import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'

import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'

import UnifiedDateTime from '../../../utils/UnifiedDateTime'

interface Props {
  expiresAt?: string
}

const List = styled.div`
  margin-top: ${cssTheme.layout.spacing.s500};
  margin-bottom: ${cssTheme.layout.spacing.s600};
`

const ListItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${cssTheme.layout.spacing.s400};

  &:not(:last-child) {
    margin-bottom: ${cssTheme.layout.spacing.s400};
  }
`

const CustomIcon = styled(Icon)`
  color: ${cssTheme.colors.content.special.c800};
  background: ${cssTheme.colors.background.special.c050};
  border-radius: ${cssTheme.layout.radius.sm};
  padding: ${cssTheme.layout.spacing.s400};
`

export const NextSteps = ({expiresAt}: Props) => {
  const expireAt = expiresAt && new Date(expiresAt)

  return (
    <div>
      <Text variant="titleL">
        <FormattedMessageWrapper
          id="dealFreeze.whatHappensNext"
          defaultMessage="What happens next:"
        />
      </Text>
      <List>
        <ListItem>
          <CustomIcon name="CalendarCheck4" />
          {expireAt && (
            <Text variant="bodyS">
              <FormattedMessageWrapper
                id="dealFreeze.bookBeforeExpirationDate"
                defaultMessage="Book by {date}, before the deal expires."
                values={{
                  date: (
                    <UnifiedDateTime
                      value={expireAt}
                      format="timefirst-longform-weekday"
                    />
                  )
                }}
              />
            </Text>
          )}
        </ListItem>

        <ListItem>
          <CustomIcon name="Mail" />
          <Text variant="bodyS">
            <FormattedMessageWrapper
              id="dealFreeze.reminderEmail"
              defaultMessage="We’ll send you an email reminder before the deal expires."
            />
          </Text>
        </ListItem>
      </List>
    </div>
  )
}
